<template>
  <b-container fluid>
    <b-spinner variant="primary" label="Spinning" v-if="loading"></b-spinner>
    <b-row v-if="!loading">
      <b-col class="p-4">
        <h2 class="text-left">{{course.title}} {{course.startDateTime | formatDate}}
          <span class="text-right">
            <div>
              <b-button-group>
                <div><b-button variant="link" :to="{name: 'CourseDetails', params: { id: $route.params.id }}">View</b-button></div>

                <course-form :text="'Edit'" :course="course" v-on:ok="save"></course-form>
              </b-button-group>
            </div>
          </span>
        </h2>
        <b-alert variant="info" show v-if="course.title.toLowerCase().startsWith('template -')">
          This is a template course.
        </b-alert>
      </b-col>
    </b-row>
    <b-row v-if="!loading">
      <b-col>
        <b-card no-body>
          <b-tabs fill card>
            <b-tab title="Students" v-if="!course.title.toLowerCase().startsWith('template -')">
              <course-users :id="course.id" :type="'Student'"></course-users>
            </b-tab>
            <b-tab title="Instructors" v-if="!course.title.toLowerCase().startsWith('template -')">
              <course-users :id="course.id" :type="'Instructor'"></course-users>
            </b-tab>
            <b-tab title="Course Resources">
              <course-links :id="course.id"></course-links>
            </b-tab>
            <b-tab title="Submitted Surveys">
              <course-surveys :courseId="course.id"></course-surveys>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Vue from 'vue'
import moment from 'moment-timezone'
import Api from '@/api/Api'
import CourseUsers from './components/CourseUsers'
import CourseForm from './components/CourseForm'
import CourseLinks from './components/CourseLinks'
import CourseSurveys from './components/CourseSurveys'

Vue.filter('formatDate', function (value) {
  return moment(value).format('MMMM Do YYYY')
})

export default {
  data () {
    return {
      loading: true,
      course: null,
      timeZone: ''
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      var vm = this
      vm.loading = true
      Api().get('Course/' + vm.$route.params.id)
        .then((r) => {
          vm.course = r.data
          console.log(vm.course)
        })
        .catch((e) => {
          if (e.response.status === 401) {
            this.$router.push({ name: 'Login' })
          } else {
            console.log(e)
          }
        })
        .finally(() => {
          vm.loading = false
        })
    },
    save (result) {
      var vm = this
      vm.loading = true
      console.log(result.course)
      Api().put('Course/' + result.course.id, result.course)
        .then((r) => {
          vm.loadData()
        })
        .finally(() => {
          vm.loading = false
        })
    }
  },
  components: {
    CourseUsers,
    CourseForm,
    CourseLinks,
    CourseSurveys
  }
}
</script>

<style>

</style>
